export default class EmployeeGrantsFilter {
  constructor() {
    this.setInitialValue();
  }
  setInitialValue() {
    this.grantToken = "";
    this.employeeToken = "";
    this.textSearch = "";
  }
  fillData(data) {
    this.grantToken = data.grantToken;
    this.employeeToken = data.employeeToken;
    this.textSearch = data.textSearch;
  }
}
